module.exports = __webpack_public_path__ + "img/hrkv.b4ffd3c5.png";